import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FeaturedProducts.css';
import { fetchFeaturedProducts } from '../products/productData';

const TAG_COLORS = {
  NEW:     { bg: '#171717', color: '#fff' },
  LIMITED: { bg: '#da291c', color: '#fff' },
  SALE:    { bg: '#e8b400', color: '#171717' },
  HOT:     { bg: '#ff6b35', color: '#fff' },
};

export default function FeaturedProducts() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchFeaturedProducts()
      .then(data => setProducts(data))
      .catch(err  => console.error(err))
      .finally(()  => setLoading(false));
  }, []);

  const handleView = (product) => {
    // Navigate to products page, pass the selected product via state
    navigate('/products', { state: { openProduct: product } });
  };

  const p     = (i) => products[i] || null;
  const img   = (i) => p(i)?.images?.[0] || 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600&q=85';
  const name  = (i) => p(i)?.name  || '—';
  const price = (i) => p(i)?.price  ? `R ${p(i).price.toLocaleString()}` : '';
  const orig  = (i) => p(i)?.originalPrice ? `R ${p(i).originalPrice.toLocaleString()}` : null;
  const tag   = (i) => p(i)?.tag   || null;
  const brand = (i) => p(i)?.brand || '';

  const Tag = ({ index }) => {
    const t = tag(index);
    if (!t || !TAG_COLORS[t]) return null;
    return (
      <span
        className="fp-tag"
        style={{ background: TAG_COLORS[t].bg, color: TAG_COLORS[t].color }}
      >
        {t}
      </span>
    );
  };

  const Card = ({ index, size }) => (
    <div className={`fp-card fp-card--${size}`} onClick={() => p(index) && handleView(p(index))}>
      <div className="fp-card__img-area">
        <Tag index={index} />
        <img src={img(index)} alt={name(index)} />
      </div>
      <div className="fp-card__foot">
        <div className="fp-card__info">
          <p className="fp-card__brand">{brand(index)}</p>
          <p className="fp-card__name">{name(index)}</p>
          <div className="fp-card__pricing">
            <span className="fp-card__price">{price(index)}</span>
            {orig(index) && <span className="fp-card__orig">{orig(index)}</span>}
          </div>
        </div>
        <button
          className="fp-btn"
          onClick={e => { e.stopPropagation(); p(index) && handleView(p(index)); }}
        >
          View
        </button>
      </div>
    </div>
  );

  if (loading) {
    return (
      <section className="featured">
        <h2 className="featured__title">FEATURED PRODUCTS</h2>
        <div className="fp-loading">
          <div className="fp-spinner" />
          <p>Loading drops...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="featured">
      <h2 className="featured__title">FEATURED PRODUCTS</h2>

      <div className="fp-grid">
        <Card index={0} size="large" />
        <Card index={1} size="medium" />
        <Card index={2} size="small" />
        <Card index={3} size="small" />
        <Card index={4} size="tall" />
      </div>
    </section>
  );
}